import { classNames } from "primereact/utils";
import React, { useMemo } from "react";

const ImagesGrid = ({ data }) => {
    const isOddCount = data.length % 2 !== 0;

    const collectionItems = useMemo(() => {
        return data.map((collection, index) => (
            <div key={index} className="collection-item">
                {collection.href ? (
                    <a href={collection.href}>
                        <img
                            src={collection.logoSrc}
                            alt={collection.alt}
                            className="collection-logo"
                            loading="lazy"
                            decoding="async"
                        />
                    </a>
                ) : (
                    <img
                        src={collection.logoSrc}
                        alt={collection.alt}
                        className="collection-logo"
                        loading="lazy"
                        decoding="async"
                    />
                )}
            </div>
        ));
    }, [data]);

    return (
        <section className="collections-section">
            <div
                className={classNames("collections-container", {
                    "odd-count": isOddCount,
                })}
            >
                {collectionItems}
            </div>
        </section>
    );
};

export default ImagesGrid;
